<template>
    <svg :width="size" :height="size" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M25.172 5.172C24.422 4.4218 23.4048 4.00023 22.344 4H8C6.93913 4 5.92172 4.42143 5.17157 5.17157C4.42143 5.92172 4 6.93913 4 8V22.344C4.00023 23.4048 4.4218 24.422 5.172 25.172L22.58 42.58C23.489 43.4833 24.7185 43.9903 26 43.9903C27.2815 43.9903 28.511 43.4833 29.42 42.58L42.58 29.42C43.4833 28.511 43.9903 27.2815 43.9903 26C43.9903 24.7185 43.4833 23.489 42.58 22.58L25.172 5.172Z"
            :stroke="color"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15 16C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14C14.4477 14 14 14.4477 14 15C14 15.5523 14.4477 16 15 16Z"
            :stroke="color"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
    name: 'ProductIcon',
    props: {
        size: {
            type: [Number, String],
            default: 24,
        },
        color: {
            type: String,
            default: 'currentColor',
        },
    },
}
</script>
